export default "/images/vendor/@coreui/icons/svg/flag/cif-so.svg?fa9b56f3affa72478630be9e2a7ee944";